import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router';

export type LazyRouteConfig = Pick<RouteObject, 'lazy'>;

/**
 * route.lazy di react-router: il router carica il chunk della pagina durante
 * la navigazione (navigation.state === 'loading' → NavigationProgress visibile,
 * vecchia pagina mantenuta, URL e UI committano insieme). Nessuna boundary
 * Suspense per-route: una ex-novo mostra subito il fallback coprendo navbar e
 * drawer (era il "flash pagina bianca" del menu). Il fallimento del chunk e
 * gli errori di render finiscono nell'errorElement radice (RouteErrorScreen).
 */
export function lazyRoute<T extends ComponentType<unknown>>(
  importer: () => Promise<{ default: T }>,
): LazyRouteConfig {
  return {
    lazy: () => importer().then((m) => ({ Component: m.default })),
  };
}

export function lazyRouteNamed<T extends ComponentType<unknown>, K extends string>(
  importer: () => Promise<Record<K, T>>,
  exportName: K,
): LazyRouteConfig {
  return {
    lazy: () => importer().then((m) => ({ Component: m[exportName] })),
  };
}
